module.exports = __webpack_public_path__ + "img/logo-ufjf.3cf76d59.png";